const  data = {
  "home.beauty_advisor": "美妆虚拟顾问",
  "home.virtual_mirror": "魔镜",
  // "home.lens_find": "一秒上眼，虚拟试戴",
  // "home.lens_continue": "开始吧！",
  "home.quiz_find": "测一测，Pick属于你的美瞳®和妆容",
  "home.logout": "退出登录",
  "home.let_us_find": "让我们帮您",
  "home.look_for_you": "适合您的妆容",
  "home.try_a_lens": "配戴镜片",
  "home.color": "花纹",
  "without_quiz.lens_color": "玩妆妙计",
  "without_quiz.access_cam": "\"美瞳®\" 想使用您的视频",
  "without_quiz.access_cam_sub_text": "用于实时试戴",
  "without_image.img_confirm": "确定使用这张图片吗？",
  "without_image.Allow" : "不允许",
  "without_image.OK": "好",
  "dba.find_look" : "让我们推荐妆感给您",
  "dba.trydba" : "试试DBA App",
  "dba.about_urself" : "告诉我们你的外貌特点",
  "dba.next" : "下一步",
  "dba.Currently wearing:" : "正在试带着",
  "quiz.skin_color" : "请选出最接近您肤色的颜色",
  "quiz.hair_Color" : "请选出最接近您发色的颜色",
  "menu.home" : "首页",
  "menu.buy" : "购买",
  "menu.share" : "分享",
  "menu.save" : "保存",
  "menu.trail" : "免费试戴",
  "menu.find" : "门店查询",
  "menu.product" : "产品信息",
  "lens.bright" : "黑棕金色 晶曦®",
  "lens.shine" : "灰金 炫闪®",
  "lens.charm" : "黑灰金色 晶茜®",
  "lens.chic" : "棕灰金色",
  "lens.sweet" : "黑棕灰金色 晶恬®",
  "lens.vivid" : "棕色 妍妍®",
  "lens.accent" : "黑色 艾姗®",
  "footer.care"  :"清洁与护理镜片",
  "footer.products" : "关于产品",
  "footer.legal": "法律聲明",
  "footer.acuvue": "关于安视优美瞳®",
  "footer.contact": "联系我们",
  "footer.privacy": "隐私政策",
  "footer.label": "关于",
  "footer.makeup" : "美妆",
  "login.email" : "电子邮件",
  "login.password": "密码",
  "login.submit" : "提交",
  "nav.welcome_guest": "欢迎用户",
  "vm.currently_wearing": "正在配戴",
  "vm.rec_variant": "推荐的颜色花纹",
  "product_info.about": "关于我们的镜片",
  "lens.now": "现在",
  "tabs.lenses": "镜片",
  "tabs.looks": "妆容",
  "tabs.makeup": "补充",
  "tabs.insertion": "配戴",
  "tabs.removal": "摘取",
  "tooltip.home": "首页",
  "tooltip.ba": "美瞳®虚拟顾问",
  "tooltip.care": "摘戴指南",
  "tooltip.more": "更多选择",
  "tooltip.buy": "购买",
  "tooltip.share": "分享",
  "tooltip.trial": "免费试戴",
  "tooltip.ecp": "门店查询",
  "tooltip.logout": "退出登录",
  "tooltip.vm": "虛擬試穿",
  "modal.share": "分享",
  "modal.buy": "购买",
  "modal.free_trial": "免费试戴",
  "modal.shop_now": "购买",
  "modal.go": "开始",
  "looks.downloadPdf": "下载 Tutorial",
  "guides.how_to_put_on_lens": "轻松配戴四步法",
  "guides.how_to_remove_lens": "轻松摘取眼镜四步骤",
  "looks.you_have_selected": "您选择的是:",
  "tutorials.or": "或",
  "tutorials.scan": "扫代码下载",
  "tutorials.product_unavailable": "此款产品在此地区暂不售卖",
  "tutorials.look": "妆容 ",
  "products.disclaimer_header": "参考",
  "tutorials.purchase": "在线购买",
  "tutorials.lens": "镜片",
  "looks.best_suited": "外观最适合",
  "looks.product_unavailable": "无法使用",
  "looks.you_have_chosen": "您已经选择",
  "looks.with_lens": "镜片",
  "looks.with_looks": "妆容",
  "permissions.allow_look_removal": "此操作将删除应用的外观",
  "permissions.allow_makeup_removal": "此操作将删除化妆",
  "permissions.allow_look_removal_sub_text": "您要继续吗？",
  "tabs.pls_select_look": "请选择外观",
  "tabs.pls_select_lens": "请选择一个镜头",
  "tabs.pls_select_makeup_category": "请选择化妆类别"
}
export default data;
